import { useState } from 'react';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { useAcademyChatActions } from '../../context/AcademyChatActionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const AcademySuggestionButtons = ({
  section,
  stepListLabels,
  disabled
}) => {
  const {
    isStreaming,
    onSuggestionClick,
    trackEvent
  } = useAcademyChatActions();
  const [hasClickedAButton, setHasClickedAButton] = useState(false);
  const actionLabels = section !== null && section !== void 0 && section.actions ? section.actions.map(a => a.label) : [];
  const labels = stepListLabels !== null && stepListLabels !== void 0 ? stepListLabels : actionLabels;
  if (!labels.length || hasClickedAButton) {
    return null;
  }
  return (
    /*#__PURE__*/
    // ButtonWrapper (not Flex) so Button's built-in adjacent-sibling
    // autospacing gets overridden instead of stacking with the gap and
    // misaligning the first button of each wrapped row.
    _jsx(ButtonWrapper, {
      horizontalGap: 8,
      verticalGap: 8,
      marginBlockStart: "400",
      children: labels.map(label => /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        size: "extra-small",
        borderRadius: "full",
        disabled: disabled || isStreaming,
        onClick: () => {
          setHasClickedAButton(true);
          trackEvent('suggestion-clicked');
          onSuggestionClick(label);
        },
        children: label
      }, label))
    })
  );
};